import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

export const searchAI = async (
  query,
  limit = 20,
  offset = 0,
  marcaFilter = "",
  temporadaFilter = "",
) => {
  const response = await axios.post(
    `${API_URL}/api/ai/search`,
    { query, limit, offset, marcaFilter, temporadaFilter },
    { withCredentials: true },
  );

  return response.data;
};

export const searchImage = async (base64Image) => {
  const response = await axios.post(
    `${API_URL}/api/ai/search-image`,
    { image: base64Image },
    { withCredentials: true },
  );

  return response.data?.hits || [];
};

export const searchEstimateImageHits = async (
  base64Image,
  numerosPresupuesto = [],
  thumbnailCandidates = [],
) => {
  const response = await axios.post(
    `${API_URL}/api/ai/search-estimate-image`,
    { image: base64Image, numerosPresupuesto, thumbnailCandidates },
    { withCredentials: true, timeout: 600000 },
  );

  return response.data;
};

export const searchEstimateImage = async (
  base64Image,
  numerosPresupuesto = [],
  thumbnailCandidates = [],
) => {
  const data = await searchEstimateImageHits(
    base64Image,
    numerosPresupuesto,
    thumbnailCandidates,
  );
  return data?.hits || [];
};

const PHOTO_SEARCH_CHUNK_SIZE = 18;

export const searchEstimateImageChunked = async (
  base64Image,
  thumbnailCandidates,
  chunkSize = PHOTO_SEARCH_CHUNK_SIZE,
) => {
  const allHits = [];
  for (let i = 0; i < thumbnailCandidates.length; i += chunkSize) {
    const chunk = thumbnailCandidates.slice(i, i + chunkSize);
    const hits = await searchEstimateImage(base64Image, [], chunk);
    allHits.push(...hits);
  }
  return allHits;
};
